import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/38_heart_dogs/38_heart_dogs"
 * Contains 1 texture(s)
 */
export class Tablet38HeartDogsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/38_heart_dogs/38_heart_dogs';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '38_heart_dogs.png'
    ] as const;
}
